import {Strings} from '@/assets';
import client from '@/query/client';
import queries from '@/query/queries';
import {Utility} from '@/utils';

class MetaParser implements MetaData {
  util: Utility;
  payment_required = false;
  base_url: string;
  embassy_letter_url = '';
  country_id = '';
  adhar_required = false;
  ask_for_adhar = false;
  ask_for_bank_details = false;
  ask_for_face_liveness = false;
  ask_for_itr = false;
  ask_supporting_documents = false;
  bank_details_required = false;
  can_change_photograph = false;
  country = '';
  fever_certificate_required = false;
  flight_details_required = false;
  itr_required = false;
  primary = false;
  subdomain: CountryType = 'greece';
  travel_dates_required = false;
  ask_fever_certificate = false;
  ask_for_visa = false;
  ask_for_photograph = false;
  ask_for_contact_details = false;
  ask_for_additional_comment = false;
  passport_required = false;
  show_download_receipt_button = false;
  post_submission_prompt = '';
  logo_url = '';
  logo_image_url = '';
  initiate_application_on_homepage = false;
  home_page_url = '';
  aadhar_service_status = '';
  itr_service_status = '';
  bank_service_status = '';

  constructor(metaData?: MetaData, visa_request_id?: string) {
    const meta =
      metaData || client.getQueryData<MetaData>(queries.meta.queryKey)!;
    this.base_url = Utility.BASE_URL;
    this.util = new Utility();

    if (visa_request_id) {
      const visaRequest = client.getQueryData<VisaRequest>(
        queries.visaRequest(visa_request_id).queryKey,
      )!;
      if (visaRequest.bundle) {
        visaRequest.required_documents.forEach(doc => {
          meta[doc] = true;
        });
      }
    }

    this.util.assign(this, meta);
  }

  get ask_for() {
    const additional = this.ask_for_additional_comment || this.ask_for_adhar;
    return {
      [Strings.ROUTES.ADDITIONAL]: additional,
      [Strings.ROUTES.VISA]: this.ask_for_visa,
      [Strings.ROUTES.PASSPORT]: this.passport_required,
      [Strings.ROUTES.FINANCIAL]: this.ask_for_bank_details || this.ask_for_itr,
      [Strings.ROUTES.PREVIEW]: true,
    };
  }

  get steps() {
    return [...Strings.PROCESS_STEPS].filter(step => this.ask_for[step.route]);
  }

  parseImage(url?: string | null | File) {
    if (!url) {
      return '';
    }
    if (url instanceof File) {
      return URL.createObjectURL(url);
    }
    return url.startsWith('https') ? url : this.base_url + url;
  }

  getGenderCode(gender: string) {
    return gender?.toLocaleLowerCase() === 'female' ? 'F' : 'M';
  }

  get new_application_url() {
    return this.home_page_url || `/${this.subdomain}`;
  }

  get is_south_korea() {
    return this.subdomain === 'southkorea';
  }

  booleanChecked(value?: boolean | null) {
    return value === null ? undefined : value;
  }

  join(strings: (string | null | undefined)[]) {
    return strings.filter(Boolean).join(' ');
  }

  isSponsor(item: BankStatement | ApplicationValidation) {
    const value =
      'bank' in item
        ? item.owner
        : 'bank_detail_owner' in item
          ? item.bank_detail_owner
          : '';
    if (typeof value === 'string') {
      return ['sponsor', 'sponser'].includes(value.toLowerCase());
    }
    return false;
  }

  isSelf = (item: BankStatement | ApplicationValidation) => {
    const value =
      'bank' in item
        ? item.owner
        : 'bank_detail_owner' in item
          ? item.bank_detail_owner
          : '';
    if (typeof value === 'string') {
      if (value === 'self') {
        return true;
      }
      return !['sponsor', 'sponser'].includes(value.toLowerCase());
    }
    return true;
  };
}

export default MetaParser;
